import React from 'react';
import {Alert} from 'reactstrap';
import {useVersionContext} from '../../context/VersionContext';

const VersionMismatchBanner: React.FC = () => {
    const {versionMismatch} = useVersionContext();

    if (!versionMismatch) {
        return null; // No mismatch => show nothing
    }

    return (
        <Alert color="warning" className="text-center mb-0">
            A new version of this application is available.{' '}
            <strong>Please refresh the page.</strong>
        </Alert>
    );
};

export default VersionMismatchBanner;
